"use client";

import Core from "@/components/core";
import Layouts from "@/components/layouts";
import { usePathname } from "next/navigation";
import { useFetchDetailLayananData } from "@/hooks/fetchDetailLayananData";
import { useState, useEffect } from "react";
import { Suspense } from "react";
import LoadingSkeleton from "@/app/loading";
import { Skeleton } from "@/components/ui/skeleton";
import dynamic from "next/dynamic";

interface LayananLayoutProps {
  children: React.ReactNode;
}

const DynamicArticles = dynamic(
  () => import("@/components/core/(Articles)/Articles"),
  {
    ssr: false,
  }
);

const LayananLayout: React.FC<LayananLayoutProps> = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const { children } = props;
  const pathname = usePathname();

  const pathPart = pathname?.split("/");
  const name = pathPart[2];
  const detailLayanan = useFetchDetailLayananData(name);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Layouts.Section>
        <Core.Title title="Services" subtitle="Layanan" />
        <div className="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
          <div className="lg:col-span-8 col-auto md:col-span-6">{children}</div>
          <div className="lg:col-span-4 col-auto md:col-span-6">
            <Layouts.SidebarLayanan title="Layanan Perbaikan">
              <Suspense fallback={<LoadingSkeleton />}>
                {isLoading ? (
                  <div className="flex flex-row pt-2">
                    <Skeleton className="h-16 rounded-md shadow w-1/4" />
                    <div className="ms-3 self-center">
                      <Skeleton className="h-4 w-full" />
                    </div>
                  </div>
                ) : (
                  <>
                    {detailLayanan
                      .sort((a: any, b: any) => b.id - a.id)
                      .map((item: any, index: any) => (
                        <DynamicArticles
                          key={index}
                          image={`https://admin.macspace.id/public/${item.image}`}
                          title={item.name}
                          link={`/layanan/${name}/${item.slug}`}
                        />
                      ))}
                  </>
                )}
              </Suspense>
            </Layouts.SidebarLayanan>
          </div>
        </div>
      </Layouts.Section>
    </>
  );
};
export default LayananLayout;
